import { useQuery } from 'react-query';
import { FeatureToggleResponse, model } from './feature-toggles';

export const queryKey = () => [`enabled-features`];
export const useFeatureToggles = () =>
  useQuery<FeatureToggleResponse>(queryKey(), () => model.get());
